import termMarkDown from './term.md';
import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';

function Terms() {
  const [markdown, setMarkdown] = useState('');

  useEffect(() => {
    fetch(termMarkDown)
      .then((res) => res.text())
      .then((text) => setMarkdown(text));
  }, []);

  return (
    <>
      <div className='content'>
        <h3>Term & Condition</h3>
        <ReactMarkdown children={markdown} />
      </div>
    </>
  );
}

export default Terms;
